import { render, staticRenderFns } from "./BugV2.vue?vue&type=template&id=48f01f0a&scoped=true&"
import script from "./BugV2.vue?vue&type=script&lang=js&"
export * from "./BugV2.vue?vue&type=script&lang=js&"
import style0 from "./BugV2.vue?vue&type=style&index=0&id=48f01f0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f01f0a",
  null
  
)

export default component.exports